var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 7.33337H3.33341L3.33341 12H4.66675V7.33337ZM8.66675 7.33337H7.33341L7.33341 12H8.66675V7.33337ZM14.3334 13.3334H1.66675V14.6667H14.3334V13.3334ZM12.6667 7.33337H11.3334V12H12.6667V7.33337ZM8.00008 2.84004L11.4734 4.66671H4.52675L8.00008 2.84004ZM8.00008 1.33337L1.66675 4.66671V6.00004L14.3334 6.00004V4.66671L8.00008 1.33337Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.3b9e5e7594a95dedc4b0b7c89db15b04.svg";
export { ForwardRef as ReactComponent };